import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { pendConstants } from "./pend.constants";

var initialState = {
	loading: false,
	error: null,
	pend: null,
	pendHistory: {
		list: [],
		error: null,
		loading: false,
		count: 0,
		page: 0,
	},
	pendDetails: {
		list: [],
		count: 0,
		page: 0,
		loading: false,
		error: null,
	},
};

export const getPendState = state => state.pend;
//prettier-ignore
const selector = property => fp.flow(getPendState, fp.property(property));

export const getPendHistoryPage = selector("pendHistory.page");

export const getPendDetailsPage = selector("pendDetails.page");

function pend(state = initialState, action) {
	switch (action.type) {
		case pendConstants.GET_PEND_REQUEST:
			return {
				...state,
				loading: true,
			};
		case pendConstants.GET_PEND_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				pend: action.pend,
			};
		case pendConstants.GET_PEND_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case pendConstants.GET_PEND_HISTORY_REQUEST:
			return {
				...state,
				pendHistory: {
					...state.pendHistory,
					loading: true,
					// page: action.page,
				},
			};
		case pendConstants.GET_PEND_HISTORY_SUCCESS:
			return {
				...state,
				pendHistory: {
					...state.pendHistory,
					loading: false,
					error: null,
					list: action.history.items,
					count: action.history.count,
				},
			};
		case pendConstants.GET_PEND_HISTORY_ERROR:
			return {
				...state,
				pendHistory: {
					...state.pendHistory,
					loading: false,
					error: action.error,
				},
			};
		case pendConstants.SET_PAGING_PEND_HISTORY:
			return {
				...state,
				pendHistory: {
					...state.pendHistory,
					page: action.page,
				},
			};
		case pendConstants.GET_PEND_LIST_REQUEST:
			return {
				...state,
				pendDetails: {
					...state.pendDetails,
					loading: true,
				},
			};
		case pendConstants.GET_PEND_LIST_SUCCESS:
			return {
				...state,
				pendDetails: {
					...state.pendDetails,
					loading: false,
					error: null,
					list: action.list.items,
					count: action.list.count,
				},
			};
		case pendConstants.GET_PEND_LIST_ERROR:
			return {
				...state,
				pendDetails: {
					...state.pendDetails,
					loading: false,
					error: action.error,
				},
			};
		case pendConstants.SET_PAGING_PEND_DETAILS:
			return {
				...state,
				pendDetails: {
					...state.pendDetails,
					page: action.page,
				},
			};
		default:
			return state;
	}
}

export default withResetState({ initialState })(pend);
